import { MaterialUiPickersDate } from "@material-ui/pickers/typings/date";
import moment from "moment";
import React, { useState } from "react";

const useStateDate = (
  initValue: any
): {
  date: MaterialUiPickersDate;
  setDate: React.Dispatch<React.SetStateAction<MaterialUiPickersDate>>;
} => {
  const [date, setDate] = useState<MaterialUiPickersDate>(
    initValue ? moment(initValue, "DD-MM-YYYY").toDate() : null
  );
  return { date, setDate };
};

export default useStateDate;
